import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';

@inject('userStore')
class EditProfile extends React.Component {
    constructor (props) {
        super(props);
        this.state = {emailsMatch: false, emailToCheck: this.props.member.email, confirmVisible: false}

    }
    render () {
        const {member} = this.props;
        let isMale = member._gender === 'MALE';
        let isFemale = member._gender === 'FEMALE';
        let isNB = member._gender === 'NON-BINARY';
        
        const dobFormatted = moment(member.dob).format("MMMM DD YYYY");
        console.log(dobFormatted);
        console.log(member);
        return (
            <div>
                <div className="section-title">Edit Profile</div>
                <div className="margin-bottom-1 margin-top-1">
                    <label className="profile-label">
                        Name <br/>
                        <input onInput={_.debounce(this.props.notify, 1100)} className="account-profile-field" onChange={() => {}} value={`${member.firstName} ${member.lastName}`}></input>
                    </label>
                </div>
                <div className="margin-bottom-1">
                    <label className="profile-label">
                        Email <br/>
                        <input className="account-profile-field" defaultValue={member.email} onChange={this.onEmailChange}></input>
                    </label>
                </div>
                {
                    this.state.confirmVisible &&
                    (
                        <div className="margin-bottom-1">
                            <label className="profile-label">
                                <span style={{
                                    color: this.state.emailsMatch ? 'black' : 'red',
                                    fontWeight: this.state.emailsMatch ? '' : 'bold'
                                }}>
                                    Confirm Email {this.state.emailsMatch ? '' : ' - Emails do not match.'}
                                </span><br/>
                                <input className="account-profile-field" onChange={this.onConfirmChange}></input>
                            </label>
                            <button className="margin-top-1 button neo mdl-sm" disabled={!this.state.emailsMatch}>Save</button>
                        </div>
                    )
                }
                <div className="margin-bottom-1">
                    {/* <label className="profile-label">
                        Password <br/>
                        <input className="account-profile-field"></input>
                    </label> */}
                    <button className="button neo mdl-sm">Reset Password</button>
                </div>
                <div className="margin-bottom-1">
                    <label className="profile-label">
                        Birthday
                    </label>
                    <input className="account-profile-field" value={dobFormatted} readOnly={true}></input>
                </div>
                <div className="margin-top-2 margin-bottom-1">
                    <label className="profile-label">
                        Gender <br/>
                    </label>
                    <div className="row margin-top-1" style={{flexFlow: 'nowrap'}}>
                        <button 
                            className={(isMale ? "button neo preselect" : "button neo") + " form mdl-wide margin-right-1"}
                            onClick={() => this.setGender('MALE')}>
                            Male
                            </button>
                        <button 
                            className={(isFemale ? "button neo preselect" : "button neo") + " form mdl-wide margin-right-1"}
                            onClick={() => this.setGender('FEMALE')}>
                            Female
                            </button>
                        <button 
                            className={(isNB ? "button neo preselect" : "button neo") + " form mdl-wide margin-right-1"}
                            onClick={() => this.setGender('NON-BINARY')}>
                            Non-Binary
                            </button>
                    </div>
                </div>
            </div>
        )
    }

    @autobind
    setGender(genderCode) {
        const {member} = this.props;
        member.gender = genderCode;
        console.log(genderCode)
        member.save();
        this.setState({});
    }

    @autobind
    onEmailChange (evt) {
        this.setState({confirmVisible: true, emailToCheck: evt.target.value});
    }

    @autobind 
    onConfirmChange (evt) {
        console.log(evt.target.value)
        console.log(`%c${this.state.emailToCheck}`, 'color: #00ff00');
        if(evt.target.value === this.state.emailToCheck) {
            this.setState({emailsMatch: true});
        }
        else {
            this.setState({emailsMatch: false});
        }

    }
}
export default EditProfile;